import { render, staticRenderFns } from "./PageNotFoundComponent.vue?vue&type=template&id=75c5c829&scoped=true&"
import script from "./PageNotFoundComponent.vue?vue&type=script&lang=js&"
export * from "./PageNotFoundComponent.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFoundComponent.vue?vue&type=style&index=0&id=75c5c829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c5c829",
  null
  
)

export default component.exports